// src/utils/sanitizeHtml.js
// Sanitizes HTML that comes from the database / content generator before it is
// rendered with dangerouslySetInnerHTML. DOMPurify's defaults already strip
// <script>, <iframe>, on* event handlers and javascript: URLs while keeping
// normal formatting (headings, lists, links, images, tables, blockquote, code).
import DOMPurify from 'dompurify';

// Any link that opens a new tab must not get a handle on window.opener.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const CONFIG = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ['target'],
  FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select'],
};

export default function sanitizeHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), CONFIG);
}
